import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Select from '../../../components/ui/Select';

const AccountsFilters = ({ onFiltersChange, activeFilters, resultCount }) => {
  const typeOptions = [
    { value: '', label: 'All Types' },
    { value: 'client', label: 'Client' },
    { value: 'prospect', label: 'Prospect' },
    { value: 'partner', label: 'Partner' },
    { value: 'vendor', label: 'Vendor' },
    { value: 'lead', label: 'Lead' }
  ];

  const industryOptions = [
    { value: '', label: 'All Industries' },
    { value: 'construction', label: 'Construction' },
    { value: 'real-estate', label: 'Real Estate' },
    { value: 'retail', label: 'Retail' },
    { value: 'hospitality', label: 'Hospitality & Food' },
    { value: 'healthcare', label: 'Healthcare' },
    { value: 'technology', label: 'Technology' },
    { value: 'finance', label: 'Finance & Insurance' },
    { value: 'education', label: 'Education' },
    { value: 'manufacturing', label: 'Manufacturing' },
    { value: 'logistics', label: 'Logistics & Transport' },
    { value: 'consulting', label: 'Consulting & Services' },
    { value: 'ecommerce', label: 'E-commerce' },
    { value: 'other', label: 'Other' }
  ];

  const statusOptions = [
    { value: '', label: 'All Statuses' },
    { value: 'active', label: 'Active' },
    { value: 'inactive', label: 'Inactive' },
    { value: 'churned', label: 'Churned' },
    { value: 'on-hold', label: 'On Hold' }
  ];

  const handleFilterChange = (filterType, value) => {
    onFiltersChange({ ...activeFilters, [filterType]: value });
  };

  const clearAllFilters = () => {
    onFiltersChange({ type: '', industry: '', status: '' });
  };

  const hasActiveFilters = Object.values(activeFilters)?.some(value => value !== '');
  const activeFilterCount = Object.values(activeFilters)?.filter(value => value !== '')?.length;

  return (
    <div className="bg-card border border-border rounded-lg p-4 mb-6">
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 flex-1">
          <Select
            options={typeOptions}
            value={activeFilters?.type || ''}
            onChange={(value) => handleFilterChange('type', value)}
            placeholder="Account Type"
          />
          <Select
            options={industryOptions}
            value={activeFilters?.industry || ''}
            onChange={(value) => handleFilterChange('industry', value)}
            placeholder="Industry"
          />
          <Select
            options={statusOptions}
            value={activeFilters?.status || ''}
            onChange={(value) => handleFilterChange('status', value)}
            placeholder="Status"
          />
        </div>

        <div className="flex items-center justify-between sm:justify-end gap-4">
          <div className="text-sm text-muted-foreground">
            {resultCount} {resultCount === 1 ? 'account' : 'accounts'} found
          </div>
          <div className="flex items-center gap-2">
            {hasActiveFilters && (
              <Button variant="ghost" size="sm" onClick={clearAllFilters} className="text-muted-foreground hover:text-foreground">
                <Icon name="X" size={16} className="mr-2" />
                Clear filters
              </Button>
            )}
            <Button variant="outline" size="sm">
              <Icon name="Download" size={16} className="mr-2" />
              Export
            </Button>
          </div>
        </div>
      </div>

      {hasActiveFilters && (
        <div className="flex flex-wrap gap-2 mt-4 pt-4 border-t border-border">
          {activeFilters?.type && (
            <div className="flex items-center gap-2 px-3 py-1 bg-primary/10 text-primary rounded-full text-sm">
              <span>Type: {typeOptions?.find(o => o?.value === activeFilters?.type)?.label}</span>
              <button onClick={() => handleFilterChange('type', '')} className="hover:bg-primary/20 rounded-full p-0.5">
                <Icon name="X" size={14} />
              </button>
            </div>
          )}
          {activeFilters?.industry && (
            <div className="flex items-center gap-2 px-3 py-1 bg-primary/10 text-primary rounded-full text-sm">
              <span>Industry: {industryOptions?.find(o => o?.value === activeFilters?.industry)?.label}</span>
              <button onClick={() => handleFilterChange('industry', '')} className="hover:bg-primary/20 rounded-full p-0.5">
                <Icon name="X" size={14} />
              </button>
            </div>
          )}
          {activeFilters?.status && (
            <div className="flex items-center gap-2 px-3 py-1 bg-primary/10 text-primary rounded-full text-sm">
              <span>Status: {statusOptions?.find(o => o?.value === activeFilters?.status)?.label}</span>
              <button onClick={() => handleFilterChange('status', '')} className="hover:bg-primary/20 rounded-full p-0.5">
                <Icon name="X" size={14} />
              </button>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default AccountsFilters;